import { TwoButtonModalV2 } from '@schenck/rotec-components';

export const MODAL_WIDTH = '732px';

export const MODAL_HEIGHT = '460px';

export const ABORT_CREATION_MODAL_DATA: TwoButtonModalV2 = {
  title: '',
  text: 'Do you really want to abort the creation process? All data will be lost.',
  summary: 'Abort Creation Process',
  confirmText: 'Abort Creation',
  cancelText: 'Cancel',
  warning: true,
  darkMode: true,
  width: MODAL_WIDTH,
};

export const ABORT_EDIT_MODAL_DATA: TwoButtonModalV2 = {
  title: '',
  text: 'Do you really want to abort the editing process? The updated data will be lost.',
  summary: 'Abort Editing Process',
  confirmText: 'Abort Editing',
  cancelText: 'Cancel',
  warning: true,
  darkMode: true,
  width: MODAL_WIDTH,
};

export const OVERWRITE_EXISTING_LOCATIONS_MODAL: TwoButtonModalV2 = {
  title: '',
  text: 'Existing locations are going to be overwritten. Are you sure you want to continue?',
  summary: 'Overwrite locations',
  confirmText: 'Overwrite',
  cancelText: 'Cancel',
  warning: true,
  darkMode: true,
  width: MODAL_WIDTH,
};

export const OVERWRITE_EXISTING_SECTORS_MODAL: TwoButtonModalV2 = {
  title: '',
  text: 'Existing sectors are going to be overwritten. Are you sure you want to continue?',
  summary: 'Overwrite sectors',
  confirmText: 'Overwrite',
  cancelText: 'Cancel',
  warning: true,
  darkMode: true,
  width: MODAL_WIDTH,
};

export const DELETE_SECTOR_MODAL: TwoButtonModalV2 = {
  title: '',
  text: 'Are you sure you want to delete the sector?',
  summary: 'Delete Sector',
  confirmText: 'COMMON_Delete',
  cancelText: 'COMMON_Cancel',
  warning: true,
  darkMode: true,
  width: '732px',
};

export const OVERWRITE_WEIGHTS_MODAL: TwoButtonModalV2 = {
  title: '',
  text: 'All current weights will be replaced.',
  summary: 'Overwrite Existing Weights',
  confirmText: 'Ok',
  cancelText: 'COMMON_Cancel',
  warning: true,
  darkMode: false,
  width: '732px',
};

export const DELETE_LOCATION_MODAL: TwoButtonModalV2 = {
  title: '',
  text: 'Are you sure you want to delete the location?',
  summary: 'Delete Location',
  confirmText: 'COMMON_Delete',
  cancelText: 'COMMON_Cancel',
  warning: true,
  darkMode: true,
  width: '732px',
};
